var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.loading
    ? _c(
        "div",
        {
          staticClass: "purchases_create atmo-page atmo-hash-jump-point",
          attrs: { id: "atmo-top" },
        },
        [
          _c(
            "b-container",
            {
              staticClass: "purchase-offer-header-block",
              attrs: { fluid: "" },
            },
            [
              _c(
                "b-container",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c(
                          "p",
                          { staticClass: "fs-40 fw-600 white-color mt-3 mb-3" },
                          [
                            _vm._v(
                              "Подача предложения на закупку 44ФЗ с неопределённым объёмом "
                            ),
                            _c("br"),
                            _vm._v("№ " + _vm._s(_vm.purchase.reg_number)),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c("p", { staticClass: "white-color fs-14" }, [
                          _vm._v("Форма подачи предложения"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-container",
            { staticClass: "my-2", attrs: { fluid: "" } },
            [
              _c(
                "b-container",
                [
                  _c(
                    "b-card",
                    { staticClass: "my-3", attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-card-header",
                        {
                          staticClass: "p-1",
                          attrs: { "header-tag": "header", role: "tab" },
                        },
                        [
                          _c(
                            "h2",
                            {
                              staticClass:
                                "grey-color font-weight-bold my-2 ml-3 cursor-pointer",
                            },
                            [_vm._v("Информация об извещении")]
                          ),
                        ]
                      ),
                      _c(
                        "b-card-body",
                        [
                          _c("text-header", [_vm._v("Информация о заказчике")]),
                          _c("text-row-link", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Наименование",
                              "router-link": {
                                name: "OrganizationShow",
                                params: { id: _vm.purchase.customer.id },
                              },
                            },
                            model: {
                              value: _vm.purchase.customer.full_name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.purchase.customer,
                                  "full_name",
                                  $$v
                                )
                              },
                              expression: "purchase.customer.full_name",
                            },
                          }),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Рейтинг",
                              value: _vm.$formatPrice(
                                _vm.purchase.customer.customer_rating
                              ),
                            },
                          }),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "ИНН",
                            },
                            model: {
                              value: _vm.purchase.customer.inn,
                              callback: function ($$v) {
                                _vm.$set(_vm.purchase.customer, "inn", $$v)
                              },
                              expression: "purchase.customer.inn",
                            },
                          }),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "КПП",
                            },
                            model: {
                              value: _vm.purchase.customer.kpp,
                              callback: function ($$v) {
                                _vm.$set(_vm.purchase.customer, "kpp", $$v)
                              },
                              expression: "purchase.customer.kpp",
                            },
                          }),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "ОГРН",
                            },
                            model: {
                              value: _vm.purchase.customer.ogrn,
                              callback: function ($$v) {
                                _vm.$set(_vm.purchase.customer, "ogrn", $$v)
                              },
                              expression: "purchase.customer.ogrn",
                            },
                          }),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Юридический адрес",
                            },
                            model: {
                              value: _vm.purchase.customer.legal_address,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.purchase.customer,
                                  "legal_address",
                                  $$v
                                )
                              },
                              expression: "purchase.customer.legal_address",
                            },
                          }),
                          _vm.purchase.purchase_terms.contact_info
                            ? _c("text-row", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 4,
                                  "label-cols-sm": 4,
                                  label: "Дополнительная контактная информация",
                                },
                                model: {
                                  value:
                                    _vm.purchase.purchase_terms.contact_info,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.purchase.purchase_terms,
                                      "contact_info",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "purchase.purchase_terms.contact_info",
                                },
                              })
                            : _vm._e(),
                          _c("text-header", [_vm._v("Условия закупки")]),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Предмет закупки",
                              value:
                                _vm.purchase.purchase_terms.deliverable_group
                                  .name,
                            },
                          }),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Объект закупки",
                              value:
                                _vm.purchase.purchase_terms.purchase_object,
                            },
                          }),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Тип закупки",
                              value:
                                _vm.purchase.purchase_terms.order_type.name,
                            },
                          }),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Продолжительность закупочной сессии",
                              value:
                                _vm.purchase.purchase_terms.duration_type.name,
                            },
                          }),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Размер аванса, %",
                              value:
                                _vm.purchase.purchase_terms.advance_percentage,
                            },
                          }),
                          _c("text-row-price", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Цена контракта",
                              value: _vm.purchase.purchase_terms.contract_price,
                            },
                          }),
                          _c("text-row-datetime", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Дата и время размещения закупки",
                              value: _vm.purchase.published_at,
                            },
                          }),
                          _c("text-row-datetime", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label:
                                "Дата и время окончания приема предложений",
                              value: _vm.purchase.purchase_end,
                            },
                          }),
                          _c("text-row-date", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Планируемая дата заключения договора",
                              value:
                                _vm.purchase.purchase_terms
                                  .planned_contract_conclusion_date,
                            },
                          }),
                          _c("text-row-date", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Планируемая дата исполнения договора",
                              value:
                                _vm.purchase.purchase_terms
                                  .planned_contract_execution_date,
                            },
                          }),
                          _c("text-row-single-document", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label: "Проект ГК",
                              value:
                                _vm.purchase.purchase_terms
                                  .contract_draft_attachment,
                            },
                          }),
                          _vm.purchase.purchase_terms
                            .commercial_proposal_form_attachment
                            ? _c("text-row-single-document", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 4,
                                  "label-cols-sm": 4,
                                  label:
                                    "Образец коммерческого предложения для заполнения",
                                  value:
                                    _vm.purchase.purchase_terms
                                      .commercial_proposal_form_attachment,
                                },
                              })
                            : _vm._e(),
                          _vm.purchase.additional_documents.length > 0
                            ? _c("text-row-documents", {
                                attrs: {
                                  compact: "",
                                  "label-cols-lg": 4,
                                  "label-cols-sm": 4,
                                  label: "Дополнительные документы",
                                },
                                model: {
                                  value: _vm.purchase.additional_documents,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.purchase,
                                      "additional_documents",
                                      $$v
                                    )
                                  },
                                  expression: "purchase.additional_documents",
                                },
                              })
                            : _vm._e(),
                          _c("text-row", {
                            attrs: {
                              compact: "",
                              "label-cols-lg": 4,
                              "label-cols-sm": 4,
                              label:
                                "Информация о возможности и случаях одностороннего расторжения сделки в соответствии с действующим законодательством Российской Федерации",
                              value:
                                _vm.purchase.purchase_terms
                                  .unilateral_contract_termination_info ??
                                "Нет",
                              "text-wrap": "",
                            },
                          }),
                          _vm.purchase.delivery_terms.addresses.length > 0 ||
                          _vm.purchase.delivery_terms.schedule
                            ? [
                                _c("text-header", [_vm._v("Условия поставки")]),
                                _vm.purchase.delivery_terms.addresses.length > 0
                                  ? _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mb-0",
                                        attrs: {
                                          "label-cols-sm": 4,
                                          "label-cols-lg": 4,
                                          label:
                                            "Адреса для доставки/самовывоза:",
                                          "label-class":
                                            "py-0 fs-14 grey-color fw-700 d-flex align-items-baseline",
                                        },
                                      },
                                      [
                                        _c(
                                          "ul",
                                          _vm._l(
                                            _vm.purchase.delivery_terms
                                              .addresses,
                                            function (address, index) {
                                              return _c(
                                                "li",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "py-0 fs-14 grey-color my-auto col-form-label",
                                                },
                                                [_vm._v(_vm._s(address))]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c("text-row", {
                                  attrs: {
                                    compact: "",
                                    "label-cols-lg": 4,
                                    "label-cols-sm": 4,
                                    label:
                                      "График поставки товаров (выполнения работ, оказания услуг)",
                                    value: _vm.purchase.delivery_terms.schedule,
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c("text-header", [
                    _vm._v("Подтверждение требований к поставщикам"),
                  ]),
                  _vm.purchase.supplier_requirements.only_smp
                    ? _c("text-row", {
                        attrs: {
                          compact: "",
                          "label-cols-sm": 11,
                          "label-cols-lg": 11,
                          "value-class": "text-right mr-2",
                          label:
                            "Участником закупки могут быть только субъекты малого предпринимательства (СМП)",
                          value: _vm.purchase.supplier_requirements.only_smp
                            ? "Да"
                            : "Нет",
                        },
                      })
                    : _vm._e(),
                  _vm.purchase.supplier_requirements.supplier_reqs_a
                    ? [
                        _c("form-row-edit-checkbox", {
                          attrs: {
                            "label-cols-sm": 11,
                            "label-cols-lg": 11,
                            "form-class": "text-right",
                            v: _vm.$v.form.supplier_requirements_confirmed
                              .supplier_reqs_a,
                            label:
                              "Подтверждаю, что соответствую требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                            compact: "",
                          },
                          model: {
                            value:
                              _vm.form.supplier_requirements_confirmed
                                .supplier_reqs_a,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.supplier_requirements_confirmed,
                                "supplier_reqs_a",
                                $$v
                              )
                            },
                            expression:
                              "form.supplier_requirements_confirmed.supplier_reqs_a",
                          },
                        }),
                        _c(
                          "div",
                          {
                            staticClass: "form-row",
                            staticStyle: { "word-break": "break-all" },
                          },
                          [
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "p",
                                { staticClass: "fs-14 grey-color my-1" },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      "Подтверждаю, что соответствую следующим требованиям"
                                    ),
                                  ]),
                                  _vm._v(
                                    " - " +
                                      _vm._s(
                                        _vm.purchase.supplier_requirements
                                          .supplier_reqs_a_details
                                          .supplier_reqs_a_text
                                      )
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "p",
                              { staticClass: "fs-14 grey-color mt-2 mb-1" },
                              [
                                _c("strong", [
                                  _vm._v(
                                    "Подтверждаю, что соответствую указанным требованиям, приложив следующие документы:"
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._l(
                          _vm.purchase.supplier_requirements
                            .supplier_reqs_a_details.supplier_reqs_a_documents,
                          function (item, index) {
                            return _c("form-row-single-line-document-upload", {
                              key: `supplier_required_document_${index}`,
                              attrs: {
                                title: item.name,
                                v: _vm.$v.form.supplier_requirements_confirmed
                                  .supplier_required_documents.$each[index]
                                  .storedDocument,
                                "label-cols-lg": 4,
                                compact: "",
                              },
                              model: {
                                value:
                                  _vm.form.supplier_requirements_confirmed
                                    .supplier_required_documents[index]
                                    .storedDocument,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.supplier_requirements_confirmed
                                      .supplier_required_documents[index],
                                    "storedDocument",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.supplier_requirements_confirmed.supplier_required_documents[index].storedDocument",
                              },
                            })
                          }
                        ),
                      ]
                    : _vm._e(),
                  _vm.purchase.supplier_requirements.supplier_reqs_b
                    ? _c("form-row-edit-checkbox", {
                        attrs: {
                          "label-cols-sm": 11,
                          "label-cols-lg": 11,
                          "form-class": "text-right",
                          v: _vm.$v.form.supplier_requirements_confirmed
                            .supplier_reqs_b,
                          label:
                            "Подтверждаю, что соответствую требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                          compact: "",
                        },
                        model: {
                          value:
                            _vm.form.supplier_requirements_confirmed
                              .supplier_reqs_b,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.supplier_requirements_confirmed,
                              "supplier_reqs_b",
                              $$v
                            )
                          },
                          expression:
                            "form.supplier_requirements_confirmed.supplier_reqs_b",
                        },
                      })
                    : _vm._e(),
                  _vm.purchase.supplier_requirements.supplier_reqs_c
                    ? _c("form-row-edit-checkbox", {
                        attrs: {
                          "label-cols-sm": 11,
                          "label-cols-lg": 11,
                          "form-class": "text-right",
                          v: _vm.$v.form.supplier_requirements_confirmed
                            .supplier_reqs_c,
                          label:
                            "Подтверждаю, что соответствую требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                          compact: "",
                        },
                        model: {
                          value:
                            _vm.form.supplier_requirements_confirmed
                              .supplier_reqs_c,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.supplier_requirements_confirmed,
                              "supplier_reqs_c",
                              $$v
                            )
                          },
                          expression:
                            "form.supplier_requirements_confirmed.supplier_reqs_c",
                        },
                      })
                    : _vm._e(),
                  _vm.purchase.supplier_requirements.supplier_reqs_sonko
                    ? _c("form-row-edit-checkbox", {
                        attrs: {
                          "label-cols-sm": 11,
                          "label-cols-lg": 11,
                          "form-class": "text-right",
                          v: _vm.$v.form.supplier_requirements_confirmed
                            .supplier_reqs_sonko,
                          label:
                            "Подтверждаю, организация является социально ориентированной некоммерческой организацией (СОНКО)",
                          compact: "",
                        },
                        model: {
                          value:
                            _vm.form.supplier_requirements_confirmed
                              .supplier_reqs_sonko,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.supplier_requirements_confirmed,
                              "supplier_reqs_sonko",
                              $$v
                            )
                          },
                          expression:
                            "form.supplier_requirements_confirmed.supplier_reqs_sonko",
                        },
                      })
                    : _vm._e(),
                  _vm.purchase.supplier_requirements.has_additional_requirements
                    ? [
                        _c("div", { staticClass: "form-row" }, [
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "p",
                              { staticClass: "fs-14 grey-color my-2 mb-1" },
                              [
                                _c("strong", [
                                  _vm._v(
                                    "Подтверждаю соответствие дополнительным требованиям, приложив следующие документы:"
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._l(
                          _vm.purchase.supplier_requirements
                            .additional_requirements,
                          function (item, index) {
                            return _c("form-row-single-line-document-upload", {
                              key: `additional_requirement_${index}`,
                              attrs: {
                                "label-cols-lg": 4,
                                title: `${index + 1}. ${
                                  item.description
                                } (причина: ${item.reason})`,
                                v: _vm.$v.form.supplier_requirements_confirmed
                                  .additional_requirements.$each[index]
                                  .attachment,
                                compact: "",
                              },
                              model: {
                                value:
                                  _vm.form.supplier_requirements_confirmed
                                    .additional_requirements[index].attachment,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.supplier_requirements_confirmed
                                      .additional_requirements[index],
                                    "attachment",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.supplier_requirements_confirmed.additional_requirements[index].attachment",
                              },
                            })
                          }
                        ),
                      ]
                    : _vm._e(),
                  _c("text-header", [_vm._v("Информация об организации")]),
                  _c("form-row-edit-text", {
                    attrs: {
                      v: _vm.$v.form.contact_name,
                      label: "Контактное лицо поставщика",
                    },
                    model: {
                      value: _vm.form.contact_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "contact_name", $$v)
                      },
                      expression: "form.contact_name",
                    },
                  }),
                  _c("form-row-single-line-document-upload", {
                    attrs: {
                      "label-cols-lg": 3,
                      "label-cols-sm": 3,
                      v: _vm.$v.form.organization_card,
                      title: "Карточка предприятия",
                    },
                    model: {
                      value: _vm.form.organization_card,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "organization_card", $$v)
                      },
                      expression: "form.organization_card",
                    },
                  }),
                  _c("form-row-edit-checkbox", {
                    attrs: { label: "Организация освобождена от уплаты НДС" },
                    model: {
                      value: _vm.form.without_vat,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "without_vat", $$v)
                      },
                      expression: "form.without_vat",
                    },
                  }),
                  _c(
                    "fl44-unknown-volume-form-row-proposal-specification-table",
                    {
                      attrs: {
                        "vat-dictionary": _vm.dictionaries.vat,
                        v: _vm.$v.form.deliverables,
                        "purchase-deliverables": _vm.purchase.deliverables,
                        "without-vat": _vm.form.without_vat,
                        "spec-errors": _vm.specErrors,
                        "spec-error-message": _vm.specErrorMessage,
                      },
                      model: {
                        value: _vm.form.deliverables,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "deliverables", $$v)
                        },
                        expression: "form.deliverables",
                      },
                    }
                  ),
                  _c(
                    "AccordionItem",
                    {
                      staticClass: "atmo-hash-jump-point mt-3",
                      attrs: {
                        visible: _vm.$route.hash === "#explanation-requests",
                        title: "Запросы разъяснений по закупке",
                        id: "explanation-requests",
                      },
                    },
                    [
                      !!_vm.purchase.id
                        ? _c("ExplanationRequestList", {
                            attrs: {
                              "purchase-item": _vm.purchase,
                              "purchase-type": "fl44UnknownVolume",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "text-header",
                    { attrs: { "margin-class": "mb-3 mt-2" } },
                    [_vm._v("Документы")]
                  ),
                  _c("form-row-single-line-document-upload", {
                    attrs: {
                      "label-cols-lg": 4,
                      v: _vm.$v.form.commercial_proposal,
                      title: "Коммерческое предложение",
                    },
                    model: {
                      value: _vm.form.commercial_proposal,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "commercial_proposal", $$v)
                      },
                      expression: "form.commercial_proposal",
                    },
                  }),
                  _c("form-row-single-line-multiple-documents-upload", {
                    attrs: {
                      "label-cols-lg": 4,
                      title: "Дополнительные документы",
                      v: _vm.$v.form.attachments,
                    },
                    model: {
                      value: _vm.form.attachments,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "attachments", $$v)
                      },
                      expression: "form.attachments",
                    },
                  }),
                  _vm.purchase.fee_amount && !_vm.form.existing_proposal
                    ? _c("p", { staticClass: "font-weight-bold grey-color" }, [
                        _vm._v(
                          "При подаче предложения на лицевом счету Вашей организации, в соответствии с регламентом, будет заблокирована сумма " +
                            _vm._s(_vm.$formatPrice(_vm.purchase.fee_amount)) +
                            " руб."
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "b-row",
                    { staticClass: "my-5" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-2",
                              attrs: { variant: "custom-outline-secondary" },
                              on: { click: _vm.cancelOffer },
                            },
                            [_vm._v("Отменить")]
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "mx-2",
                              attrs: {
                                disabled:
                                  _vm.$v.$invalid ||
                                  !_vm.$store.getters.getCanSign,
                                variant: "custom-green",
                              },
                              on: { click: _vm.validateForm },
                            },
                            [_vm._v("Подать предложение")]
                          ),
                          !_vm.$store.getters.getCanSign
                            ? [
                                _vm.$store.getters.getLoginType === "cert"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                                      },
                                      [
                                        _vm._v(
                                          "Для действия требуется загрузить/заменить МЧД на странице: "
                                        ),
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "green-link",
                                            attrs: {
                                              to: {
                                                name: "CabinetUserProfile",
                                              },
                                            },
                                          },
                                          [_vm._v("Данные учетной записи")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                                      },
                                      [
                                        _vm._v(
                                          "Подача и изменение предложения возможны только при авторизации при помощи ЭЦП"
                                        ),
                                      ]
                                    ),
                              ]
                            : _vm.$v.$invalid &&
                              !_vm.$v.form.accountingAvailable
                            ? [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-danger px-3 pt-0 fs-14 w-50 my-auto",
                                  },
                                  [
                                    _vm._v("Необходимо для блокировки "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$formatPrice(
                                            _vm.purchase.fee_amount
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(
                                      " руб. Для подачи предложения не хватает "
                                    ),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$formatPrice(
                                            Math.abs(
                                              _vm.roundToTwoDecimals(
                                                _vm.accounting.sum_available +
                                                  _vm.accounting
                                                    .already_blocked_sum -
                                                  _vm.commission
                                              )
                                            )
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" руб."),
                                  ]
                                ),
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "system_link-style fs-14",
                                    attrs: {
                                      to: { name: "CabinetAccounting" },
                                    },
                                  },
                                  [_vm._v("Пополнить лицевой счет")]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "b-modal",
            {
              ref: "sign-form-modal",
              attrs: {
                centered: "",
                "hide-header-close": "",
                "no-close-on-backdrop": "",
                "no-close-on-esc": "",
                size: "lg",
                title: "Подписать предложение",
              },
              model: {
                value: _vm.showSignModal,
                callback: function ($$v) {
                  _vm.showSignModal = $$v
                },
                expression: "showSignModal",
              },
            },
            [
              _c(
                "div",
                { staticClass: "d-block text-left" },
                [
                  _c(
                    "b-tabs",
                    { attrs: { "content-class": "mt-3" } },
                    [
                      _c(
                        "b-tab",
                        {
                          attrs: { active: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "system_link-style fs-16",
                                      },
                                      [_vm._v("Форма")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2602645129
                          ),
                        },
                        [
                          _c("text-row", {
                            attrs: { label: "Закупочная сессия" },
                            model: {
                              value: _vm.purchase.reg_number,
                              callback: function ($$v) {
                                _vm.$set(_vm.purchase, "reg_number", $$v)
                              },
                              expression: "purchase.reg_number",
                            },
                          }),
                          _c("h4", { staticClass: "font-weight-bold" }, [
                            _vm._v("Спецификация"),
                          ]),
                          _c("b-form-group", [
                            _c(
                              "ul",
                              _vm._l(
                                _vm.form.deliverables,
                                function (item, index) {
                                  return _c(
                                    "li",
                                    {
                                      key: index,
                                      staticClass:
                                        "fs-14 grey-color my-auto col-form-label py-1",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(index + 1 + ".") +
                                          " " +
                                          _vm._s(
                                            _vm.getPurchaseDeliverable(item.id)
                                              .ktru_item.name
                                          ) +
                                          " - " +
                                          _vm._s(
                                            _vm.getPurchaseDeliverable(item.id)
                                              .ktru_item.okei_local_symbol
                                          ) +
                                          ": Цена за ед. " +
                                          _vm._s(item.price) +
                                          " руб." +
                                          _vm._s(
                                            _vm.form.without_vat
                                              ? ""
                                              : `, НДС${item.vat}%`
                                          )
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "b-tab",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "system_link-style fs-16",
                                      },
                                      [_vm._v("XML")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            119620390
                          ),
                        },
                        [
                          !_vm.isSignedXml
                            ? _c("b-form-textarea", {
                                staticClass: "text-monospace fs-12",
                                attrs: {
                                  disabled: "",
                                  "no-auto-shrink": "",
                                  "no-resize": "",
                                  rows: "20",
                                  wrap: "off",
                                },
                                model: {
                                  value: _vm.formXml,
                                  callback: function ($$v) {
                                    _vm.formXml = $$v
                                  },
                                  expression: "formXml",
                                },
                              })
                            : _c("b-form-textarea", {
                                staticClass: "text-monospace fs-12",
                                attrs: {
                                  disabled: "",
                                  "no-auto-shrink": "",
                                  "no-resize": "",
                                  rows: "20",
                                  wrap: "off",
                                },
                                model: {
                                  value: _vm.signedFormXml,
                                  callback: function ($$v) {
                                    _vm.signedFormXml = $$v
                                  },
                                  expression: "signedFormXml",
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "w-100 px-3",
                  attrs: { slot: "modal-footer" },
                  slot: "modal-footer",
                },
                [
                  _c("text-row", {
                    attrs: {
                      value: _vm.certificate?.subjectName,
                      label: "Сертификат",
                    },
                  }),
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-2 text-uppercase",
                      attrs: {
                        disabled: _vm.isDataSending,
                        variant: "custom-outline-secondary",
                      },
                      on: { click: _vm.cancelSignModal },
                    },
                    [_vm._v("Отмена")]
                  ),
                  !_vm.isSignedXml
                    ? _c(
                        "b-overlay",
                        {
                          staticClass: "d-inline-block",
                          attrs: {
                            show: _vm.isSigningXml,
                            opacity: "0.6",
                            rounded: "",
                            "spinner-small": "",
                            "spinner-variant": "primary",
                          },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "text-uppercase",
                              attrs: {
                                disabled: !_vm.certificate,
                                variant: "custom-green",
                              },
                              on: { click: _vm.signForm },
                            },
                            [_vm._v("Подписать")]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "b-overlay",
                        {
                          staticClass: "d-inline-block",
                          attrs: {
                            show: _vm.isDataSending,
                            opacity: "0.6",
                            rounded: "",
                            "spinner-small": "",
                            "spinner-variant": "primary",
                          },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "text-uppercase",
                              attrs: {
                                disabled: !_vm.certificate,
                                variant: "custom-green",
                              },
                              on: { click: _vm.sendData },
                            },
                            [_vm._v("Отправить")]
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }